<template>
  <SearchContainers>
    <InfoSearchFormComponent
      slot="search-form"
      v-model="formValues"
      :infoTypesOptions="infoTypesOptions"
      :defaultValues="defaultValues"
      v-on:sendQuery="queryChanged"
    />
    <FolderSearchResultsComponent
      slot="search-results"
      :folderList="aktaList"
      :resultsLoading="aktasLoading"
    >
    </FolderSearchResultsComponent>
    <SearchOrderingContainer 
      slot="search-order"
      :defaultSorts="infoSorts"
      v-on:currentSortChanged="sortChangeHandler"
    />
    <a-pagination 
      v-model="page"
      :pageSize="pagination.results"
      :defaultPageSize="9"
      :total="pagination.total"
      slot="pagination-top"
    >
    </a-pagination>
    <a-pagination 
      v-model="page"
      :pageSize="pagination.results"
      :defaultPageSize="9"
      :total="pagination.total"
      slot="pagination-bottom"
    >
    </a-pagination>
  </SearchContainers>
</template>

<script>
import InfoSearchFormComponent from '@/components/app/info_components/InfoSearchFormComponent.vue';
import FolderSearchResultsComponent from '@/components/app/folder_components/FolderSearchResultsComponent.vue';
import SearchOrderingContainer from '@/components/app/search_components/SearchOrderingContainer.vue';
import SearchContainers from '@/components/app/search_components/SearchContainers.vue';
import { GET_AKTAS_LIST } from '../../../store/action_types';


const infoTypesOptions = [
    { label: 'Normál', value: 'normal'},
    { label: 'Kiemelt', value: 'special'},
]

const defaultValues = {
    isEmphasized: [],
    tags: [],
    persons: [],
    topics: [],
    modifiedAt: [],
    priority: [1, 5],
    uniqueId: '',
    name: '',
    description: ''
}


export default {

    components: {
        InfoSearchFormComponent,
        SearchOrderingContainer,
        SearchContainers,
        FolderSearchResultsComponent
    },

    data() {
      return {
        pagination: {
          page: 1,
          results: 9,
          total: 0
        },
        infoSorts: {
          priority: {
            name: 'Prioritás szerint',
            order: ''
          },
          modifiedAt: {
            name: 'Módosítás ideje szerint',
            order: ''
          },
          createdAt: {
            name: 'Megjelenés ideje szerint',
            order: ''
          }
        },
        currentSort: {
          sortOrder: '',
          sortKey: ''
        },
        infoTypesOptions,
        formValues: {
          ...defaultValues
        },
        queryValues: {
          ...this.formValues
        },
        defaultValues,
        aktasLoading: false
      }
    },

    computed: {
        aktaList() {
          return this.$store.state.akta_module.displayedAktas;
        },
        page: {
          get() {
            return this.pagination.page
          },
          set(val) {
            this.pagination = {
              ...this.pagination,
              page: val
            }
            this.requestAktas()
          }
        }
    },
    methods: {
      sortChangeHandler(currentSort) {
        this.currentSort = currentSort;
        this.requestAktas();
      },
      queryChanged(values) {
        this.queryValues = {...values}
        this.requestAktas();
      },
      requestAktas() {
        this.aktasLoading = true;

        const values = {...this.queryValues};
        const formKeys = Object.keys(values);
        const searchProperties = [];
        formKeys.forEach(key => {
          if (key === 'isEmphasized') {
            if (values[key].length === 1 && values[key][0] === 'special') {
              searchProperties.push(['FolderInfo', key, true]);
            } 
          } else if (values[key]) {
            if (!Array.isArray(values[key])) {
              searchProperties.push(['FolderInfo', key, values[key]]);
            } else if (values[key].length > 0) {
              searchProperties.push(['FolderInfo', key, values[key]]);
            }
            
          }
        });

        const pagination = {
          ...this.pagination
        }

        const sorting = {};
        if (this.currentSort.sortField) {
          sorting.sortField = `FolderInfo.${this.currentSort.sortField}`;
        }
        if (this.currentSort.sortOrder) {
          sorting.sortOrder = this.currentSort.sortOrder;
        }

        const searchOptions = {
          ...pagination,
          ...sorting,
          properties: [
            ...searchProperties,
            ['FolderInfo', 'isInfo', false]
          ]
        }

        

        this.$store.dispatch({
          type: GET_AKTAS_LIST,
          options: searchOptions
        }).then(res => {

          const total = res.data.meta.total;
          const results = res.data.meta.results;
          const page = Math.ceil(total / results) >= page ? res.data.meta.page : 1

          const newPagination = {
            page,
            results,
            total
          }

          this.pagination = newPagination;
          this.aktasLoading = false;
        })
      }
    }
}
</script>

<style lang="scss" scoped>
    .files-filter-form-container {
        border: 1px solid $primary-blue;
        border-radius: 5px;
        padding:20px;
    }

    .files-result-sortings {
      margin-top: 15px;
      margin-bottom: 15px;
    }
</style>